import moment from 'moment';

export const getImportJobStatusColor = (status?: string | null): string => {
  if (status === 'PROCESSING') return 'blue';
  if (status === 'COMPLETED') return 'green';
  if (status?.startsWith('FAILED')) return 'red';
  return 'default';
};

export const formatImportJobDate = (date?: string | null): string => {
  if (!date) return '-';
  return moment(date).format('MMM D, YYYY HH:mm');
};

export const formatLastRefreshedAt = (date?: Date | null): string => {
  if (!date) return '';
  return moment(date).format('MMM D, YYYY [at] HH:mm');
};

export const getImportJobFilename = (s3Key?: string | null): string => {
  if (!s3Key) return '-';
  return s3Key.split('/').pop() || s3Key;
};
